import checkIcon from '../images/check-icon.svg'
import { CommonGoalType } from "../components/CommonGoal";

interface ProgressSelectorProps {
    commonGoalId: number;
    selectedGoal: number;
    handleOnChangeSelector: any;
    isCompleted: boolean,
    goalDescription: string;
    commonGoalList: CommonGoalType[];
}

export default function ProgressSelector({ commonGoalId, commonGoalList, isCompleted, goalDescription, selectedGoal, handleOnChangeSelector }: ProgressSelectorProps) {

    return (
        <>
            <div className="ProgressDialog-goal-title-container">
                <label htmlFor="goals" className='hide'>เป้าหมาย</label>
                <select name="goals" id="goals" value={selectedGoal} onChange={handleOnChangeSelector} className="selector blue elicpse bg-white" style={{ width: '79%', marginLeft: '-0.3rem', marginRight: '0.5rem' }}>
                    {commonGoalList.map(({ id, goal }) => (
                        <option style={{ color: 'black' }} key={id} value={id} >{goal}</option>
                    ))}
                </select>
                <div className="ProgressDialog-goal-status" style={isCompleted ? { backgroundColor: '#E4FFF7' } : { backgroundColor: '#F2F2F2' }}>
                    {
                        isCompleted ? (
                            <div style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
                                <img src={checkIcon} alt="checkIcon" />
                                <p style={{ color: '#009C6D' }}>Completed</p>
                            </div>
                        ) : (
                            <p>Not Complete</p>
                        )
                    }
                </div>
            </div>
            <p className="ProgressDialog-goal-desc">{goalDescription}</p>
        </>
    )
}